module.exports = __webpack_public_path__ + "static/ISOTransparent-ef9a4414479598688581f68e066758d2.png";